import PasswordManagementView from "./PasswordManagementView";

export { PasswordManagementView };
export default PasswordManagementView;
